import {
  useProducts,
  UseReorderHistoryProps
} from 'componentsV2/product/details/content/subpages/order-history/hooks';
import { Product } from '@setvi/shared/interfaces';
import { ProductsEmptyState } from 'componentsV2/product/details/content/components';
import { ListLoader } from '../../../list/components/product-card/list/components';

interface MobileOrderHistoryProps extends UseReorderHistoryProps {
  selectedProducts: Product[];
}

export const MobileOrderHistory = ({
  selectedProducts,
  ...rest
}: MobileOrderHistoryProps) => {
  const { products, isLoading } = useProducts(rest);

  if (isLoading) return <ListLoader />;

  if (!products?.length && !isLoading)
    return <ProductsEmptyState title="No order history found" />;

  return <></>;
};
